<!--web的列表,带分页,逻辑:
	传入的列表为当前渲染的列表,长度为设置的页长,超出的会被过滤
	下面的页码根据页长和设置的总数来显示,点击时抛出选中的页面
	上层界面根据选中的页码来传入对应的数据,组件本身不关心
	columns是标题,字段name为显示的文字,字段key为对应的字段,数据显示会根据对应字段来
	左右都箭头后面应该换成图片并且遮罩在table上面半透明,开发过程中随便了
-->
<template>
  <div class="infoListBody">
    <!--		<div>-->
    <!--			<iconButton @buttonClick='downloadExcel' buttonText='导出' icoName="wedoButton/download.png"></iconButton>-->
    <!--		</div>-->
    <div class="infolist-out-table-box custom-scrollbar" :class="{'infolist-out-table-box-indexshow':showIndex}"
      :id="bodyId">
      <div class="infolist-in-table-box hideBar">
        <table id="table_data" class="infolist-table-body " cellspacing="0" align="center" border="1">
          <!--					<tr :id="bodyId+'fixedTr'" class="infolist-table-title" @click.stop="nowCheckIndex = -1;$emit('clickTableHead')">-->
          <!--						<td class="info-list-no" style="width: .25rem;"></td>-->
          <!--						<th v-for="(column,r) in columns" :style="getWidth(column,r)" :key="r">{{column.name}}</th>-->
          <!--					</tr>-->
          <tr :id="bodyId+'nomalTr'" @click="$emit('clickTableHead')" class="thable">
            <td class="info-list-no" style="width: .25rem;"></td>
            <th v-for="(column,r) in columns" :style="getWidth(column,r)" :key="r">{{column.name}}</th>
          </tr>
          <tr v-for="l in parseInt(pageLen)" v-show="l <= 20 || l <= dataList.length"
            @click.stop="nowCheckIndex = l <= dataList.length ? l:-1;$emit('clickTableBody', dataList[l-1])"
            :class="{nowChecked:nowCheckIndex == l}" :style="trStyle(dataList[l-1])" class="infolist-table-body-bg1"
            :key="l" @dblclick.stop="$emit('dblclick',dataList[l-1])">
            <td class="info-list-no" :style="getNoStyle">{{pageLen*nowIndex + l}}</td>
            <template v-for="(column,r) in columns">
              <td :key='r' v-if='column.type=="slot"' :style="getWidth(column,r,getLabel(l-1,column,r))">
                <slot :name="column.key" :index='l-1' :item='dataList[l-1]'>
                </slot>
              </td>
              <td v-else :style="getWidth(column,r,getLabel(l-1,column,r))" :key="r">{{getLabel(l-1,column,r)}}</td>
            </template>
          </tr>
        </table>
      </div>
    </div>
    <div class="info-list-index" ref="foot" v-if="showIndex != false">
      <div class="index-div" :style='indexStyle'>共 <span>{{totalSize}}</span> 条 , <span>{{maxPageIndex+1}} </span>页
      </div>
      <div :style="unClickAble(0)" class="index-div page-border" @click="nowIndex = 0">首页</div>
      <div :style="unClickAble(0)" class="index-div page-border" @click="nowIndex - 1 >= 0?nowIndex-=1:''">上一页</div>
      <div class="index-div" :style='indexStyle' v-show="type == 1 || type == 3">...</div>
      <div class="index-div page-border" :style='indexStyle' @click="nowIndex = item" v-for="item in pageIndexs"
        :class="{'nowselect':item == nowIndex}" :key="item">{{item+1}}</div>
      <div class="index-div" :style='indexStyle' v-show="type == 2 || type == 3">...</div>
      <div :style="unClickAble(maxPageIndex)" class="index-div page-border"
        @click="nowIndex + 1 <= maxPageIndex?nowIndex+=1:''">下一页</div>
      <div :style="unClickAble(maxPageIndex)" class="index-div page-border" @click="nowIndex = maxPageIndex"
        style="margin-right: .2rem;">末页</div>
    </div>
  </div>
</template>

<script>
  import resourcesStore from '../../../cache/resourcesStore.js'
  import iconButton from '@/components/module/universal/iconButton.vue'
  export default {
    components: {
      iconButton
    },
    /**
     * dataType:值类型,默认是0键值对,如果是数组按顺序那种的话,就传1
     * getTdStyleMethod:定制td样式的,如果没有就不管,如果第三个参数是undefined则是标题的样式
     * addEmptyColumn:是不是自动加空行到填满
     */
    props: {
      indexStyle: {
        type: Object,
        default () {
          return {}
        }
      },
      columns: {
        type: Array,
        default () {
          return []
        }
      },
      dataList: {
        type: Array,
        default () {
          return []
        }
      },
      pageLen: {
        type: Number,
        default: 20
      },
      totalSize: {
        type: Number,
        default: 0
      },
      fillAll: {
        type: Boolean,
        default: false
      },
      dataType: {
        type: Number,
        default: 0
      },
      showIndex: {
        type: Boolean,
        default: true
      },
      addEmptyColumn: {
        type: Boolean,
        default: true
      },
      noStyle: {
        type: Object,
        default: undefined
      },
      titleStyle: {
        type: Object,
        default: undefined
      },
      spanColor: {
        type: String,
        default: undefined
      },
      hideBorder: {
        type: Boolean,
        default: false
      },
      checkedFirst: {
        type: Boolean,
        default: false
      },
      trStyle: {
        type: Function,
        default (item) {
          return {}
        }
      }
    },
    data () {
      return {
        scrollTimer: undefined,
        scrollType: 0, //0不滑动1滚动条向左-1滚动条向右
        nowIndex: 0, //当前页码
        type: -1, //-1未初始化0没有多余页面1左边有多2右边有多3左右都有多
        nowCheckIndex: -1, //当前选中项,翻页就是-1
        taskid: randomPkid(),
        bodyId: randomPkid(),
        bodyBean: undefined,
        fixedTr: undefined,
        nomalTr: undefined,
        nowBodyWidth: 0, //当前容器宽度
      }
    },
    created () {},
    mounted () {
      if(this.checkedFirst&&!isempty(this.dataList)) {
        this.nowCheckIndex=1
      }
      this.bodyBean=document.getElementById(this.bodyId)
      this.fixedTr=document.getElementById(this.bodyId+"fixedTr")
      this.nomalTr=document.getElementById(this.bodyId+"nomalTr")
      addNewTask(this.taskid,10,200,-1,() => {
        //保持固定的tr和普通tr一样宽，以保证不会错位
        this.refreshBeanWidth()
      })

    },
    destroyed () {
      removeTask(this.taskid)
    },
    computed: {
      getNoStyle () {
        if(!isempty(this.noStyle)) {
          return this.noStyle
        }
        return this.getColorStyleById('infoListTextColor')
      },
      getBackgroudImageStyle () {
        return resourcesStore.getters.getBackgroudImageStyle
      },
      getBackgroudColorStyle () {
        return resourcesStore.getters.getBackgroudColorStyle
      },
      getResourcesByName () {
        return resourcesStore.getters.getResourcesByName
      },
      getColorById () {
        return resourcesStore.getters.getColorById
      },
      getColorStyleById () {
        return resourcesStore.getters.getColorStyleById
      },
      unClickAble () {
        return targetIndex => {
          if(this.nowIndex==targetIndex) {
            return {
              'border-color': this.getColorById('infoListTextUnClickAbleColor'),
              'color': this.getColorById('infoListTextUnClickAbleColor')
            }
          }
          if(!isempty(this.indexStyle)) {
            return this.indexStyle
          }
          return {}
        }
      },
      weights () {
        //每个列表项的宽度份额
        if(this.fillAll==true) {
          //总份数
          var count=0

          this.columns.forEach(item => {
            if(item.weight!=undefined) {
              count+=item.weight
            } else {
              count+=1
            }
          })
          if(count==0) {
            return []
          }
          //计算每份额
          var per=1/count
          var weights=[]
          this.columns.forEach(item => {
            if(item.weight!=undefined) {
              weights.push(item.weight*per)
            } else {
              weights.push(per)
            }
          })
          var count=weights.reduce((a,b) => {
            return a+b
          })
          if(count>1) {
            weights[weights.length-1]-=(count-1)
          }
          return weights
        }
        return []
      },
      getWidth () {
        return (column,r,value) => {
          var baseStyle={}
          if(isempty(this.spanColor)) {
            baseStyle.color=this.getColorById('infoListTextColor')
          } else {
            baseStyle.color=this.spanColor
          }
          if(value!=undefined&&column.getTdStyleMethod!=undefined) {
            baseStyle=Object.assign(baseStyle,column.getTdStyleMethod(column,r,value))
          }
          if(this.weights[r]!=undefined) {
            //多预留1像素
            var targetWidth=Math.floor((this.nowBodyWidth-35)*this.weights[r]-12)+'px'
            baseStyle['min-width']=targetWidth
            baseStyle['max-width']=targetWidth
            baseStyle.width=targetWidth
          }
          if(isempty(this.weights)&&this.fillAll==false&&this.nomalTr) {
            var targetWidth=150+'px'
            baseStyle['min-width']=targetWidth
            baseStyle['max-width']=targetWidth
            baseStyle.width=targetWidth
          }
          var temp={
            '-webkit-box-orient': 'vertical',
            'overflow': 'hidden',
            'word-break': 'break-all',
          }
          if(this.hideBorder) {
            // temp['border-bottom'] = '0.01rem dashed #CCCCCC'
          } else {
            // temp.border= '0.01rem dashed #CCCCCC'
          }
          Object.assign(baseStyle,temp)
          return baseStyle
        }
      },
      maxPageIndex () {
        //根据长度计算出来的最大页码
        try {
          if(this.totalSize<=0||this.pageLen<=0) {
            return 0
          }
          var max=this.totalSize/this.pageLen
          if(this.totalSize%this.pageLen==0) {
            return (max|0)-1
          }
          return max|0
        } catch(e) {
          return 0
        }
      },
      indexType () {
        if(this.maxPageIndex>10) {
          if(this.nowIndex<=4) {
            //显示从0开始,右边有多
            return 2
          } else if(this.nowIndex+5>=this.maxPageIndex) {
            //显示从右边开始,左边有多
            return 1
          } else {
            return 3
          }
        } else {
          //显示全部
          if(this.maxPageIndex==-1) {
            return -1
          } else {
            return 0
          }
        }
      },
      pageIndexs () {
        //显示出来的页码,只显示当前页的前和后2
        var list=[]
        //页码足够多时,只显示当前页前4和后5共10页
        switch(this.indexType) {
          case -1:
            list.push(0)
            return
          case 0:
            for(var i=0;i<=this.maxPageIndex;i++) {
              list.push(i)
            }
            break;
          case 1:
            for(var i=9;i>=0;i--) {
              list.push(this.maxPageIndex-i)
            }
            break;
          case 2:
            for(var i=0;i<=9;i++) {
              list.push(i)
            }
            break;
          case 3:
            for(var i=this.nowIndex-4;i<=this.nowIndex+5;i++) {
              list.push(i)
            }
            break;
        }
        return list
      },
      getPkid () {
        return (index,column,columnIndex) => {
          return this.dataList[index].pkid
        }
      },
    },
    watch: {
      dataList (nv,ov) {
        //切换的时候清除选中
        this.resetNowCheckIndex()
      },
      nowIndex (nv,ov) {
        this.$emit("selectPage",nv)
        this.resetNowCheckIndex()
      },
      nowCheckIndex (nv,ov) {
        if(nv!=-1) {
          this.$emit("checkItem",this.dataList[nv-1])
        } else {
          this.$emit("checkItem")
        }
      },
      maxPageIndex (nv,ov) {
        if(this.nowIndex==0) {
          this.$emit("selectPage",this.nowIndex)
          this.resetNowCheckIndex()
        } else {
          this.nowIndex=0
        }
      }
    },
    methods: {
      downloadExcel (titleName) {
        let title='<thead><tr>'
        title+='<th colspan=6>'+new Date().formatByTime('-')+titleName+'</th>'
        title+='</tr></thead>'
        let k=document.getElementById("table_data").outerHTML;
        let table=title+k
        exportToExcel(table,titleName+"报告")
      },
      resetNowCheckIndex () {
        if(this.checkedFirst&&!isempty(this.dataList)) {
          this.nowCheckIndex=1
        } else {
          this.nowCheckIndex=-1
        }
      },
      getLabel (index,column,columnIndex) {
        //获取第l行第r格的内容
        if(this.dataList[index]==undefined) {
          return ''
        }
        var data
        if(this.dataType==1) {
          //数组型数据
          data=this.dataList[index][columnIndex]
        } else {
          //默认键值对型数据
          data=this.dataList[index][column.key]
        }
        if(column.format!=undefined) {
          //数据需要经过处理
          return column.format(data,this.dataList[index])
        }
        return data
      },
      getTdStyleMethod (column,index,value) {
        var sty={
          'overflow': 'hidden',
          /*超过部分不显示*/
          'text-overflow': 'ellipsis',
          /*超过部分用点点表示*/
          'white-space': 'nowrap',
          /*不换行*/
        }
        if(column.getTdStyleMethod!=undefined) {
          try {
            Object.assign(sty,column.getTdStyleMethod(column,index,value))
          } catch(e) {
            err(e.stack)
          }
        }
        return sty
      },
      refreshBeanWidth () {
        //刷新控件宽度
        if(this.bodyBean!=undefined&&this.bodyBean.offsetWidth!=this.nowBodyWidth) {
          this.nowBodyWidth=this.bodyBean.offsetWidth
        }
        if(this.fixedTr!=undefined&&this.nomalTr!=undefined) {
          this.fixedTr.style.width=this.nomalTr.offsetWidth+'px'
        }
      }
    }
  }
</script>

<style scoped>
  .infoListBody {
    /* height: 2.5rem !important; */
    /* width: 86% !important; */
    background: #FCFCFC;
  }

  .thable {
    background-color: #f3f8ff;
  }

  .thable td,
  .thable th {
    font-weight: bold !important;
    color: #999999;
    font-size: 14px !important;
    border-right: 1px solid #ddd;
  }

  .infolist-out-table-box {

    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;
    /* padding: 5px; */
  }

  .infolist-out-table-box-indexshow {
    /*height: calc(100% - .6rem) !important;*/
    height: calc(100% - .9rem) !important;
  }

  .infolist-in-table-box {
    display: inline-block;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    float: left;
  }

  .infolist-table-body {
    /* width: auto; */
    width: 100%;
    height: auto;
    overflow: hidden;
    table-layout: fixed;
    border: 1px solid #ddd;
    /* border-bottom: 1px solid #ddd; */
  }

  .infolist-table-body th {
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .infolist-table-body th,
  .infolist-table-body td {
    padding: 0 .05rem;
    min-width: 75px;
    /* height: .36rem; */
    /* line-height: .18rem; */
    font-size: .12rem;
    text-align: center;
    font-weight: normal;
    height: 39px;

  }

  .infolist-table-body .info-list-no {
    min-width: 25px !important;
    max-width: 25px !important;
    text-align: center;
  }

  .infolist-table-title {
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #ddd;
    /* margin-left: 5px;
		margin-top: 5px; */
  }

  .infolist-table-title td,
  .infolist-table-title th {
    border-right: 1px solid #ddd;
    height: 40px;
  }

  .infolist-table-body-bg1 td {
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;

  }

  .infolist-table-body-bg1 td:last-child {
    border-right: 0;
  }

  /**
	 * 页码
	 */
  .page-border {
    border-radius: 5px;
    border-width: 1px;
    border-style: solid;
    margin: 4px;
  }

  .info-list-index {
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: .6rem;
  }

  .index-div {
    font-size: .06rem;
    cursor: pointer;
    min-width: 30px;
    text-align: center;
    line-height: .2rem;
    padding: 1px 5px;
  }
</style>